import $ from 'jquery';
import 'slick-carousel';


export const mountSlider = ($slider, initCallBack, responsive) => {
  if ($slider === undefined) {
    console.error("Can't mount undefined slider");
    return false;
  }


  if ($slider.data('desktop-only') == "1" && $(window).width() <= 989) return false;
  if ($slider.data('mobile-only') == "1" && $(window).width() > 989) return false;
  if ($slider.data('small-divice-only') == "1" && $(window).width() > 767) return false;
  if (typeof initCallBack === 'function') {
    $slider.on('init', initCallBack);
  }

  const $controls = $slider.parent().find('.slider-controls');
  const options = {
    slidesToShow: $slider.data('slides-to-show') || 1,
    slidesToScroll: $slider.data('slides-to-scroll') || 1,
    draggable: ($slider.data('draggable') == false) ? false : true,
    infinite: ($slider.data('infinite') == false) ? false : true,
    adaptiveHeight: ($slider.data('adaptive-height') == true) ? true : false,
    arrows: ($slider.data('arrows') == false) ? false : true,
    dots: ($slider.data('dots') == false) ? false : true,
    autoplay: ($slider.data('autoplay') == true) ? true : false,
    centerMode: ($slider.data('centermode') == true) ? true : false,
    variableWidth: ($slider.data('variable-width') == true) ? true : false,
    accessibility: true
  }

  const optionsMobile = {
    slidesToShow: $slider.data('slides-to-show-mob') || options.slidesToShow,
    slidesToScroll: $slider.data('slides-to-scroll-mob') || options.slidesToScroll,
    draggable: ($slider.data('draggable-mob') == false) ? false : true,
    infinite: ($slider.data('infinite-mob') == false) ? false : true,
    adaptiveHeight: ($slider.data('adaptive-height-mob') == true) ? true : false,
    arrows: ($slider.data('arrows-mob') == false) ? false : true,
    dots: ($slider.data('dots-mob') == false) ? false : true,
    autoplay: ($slider.data('autoplay-mob') == true) ? true : false,
    centerMode: ($slider.data('centermode-mob') == true) ? true : false,
    variableWidth: ($slider.data('variable-width-mob') == true) ? true : false,
    accessibility: true
  }

  if ($slider.data('custom-controls') == "1") {
    options['appendDots'] = $controls.find('[data-hor-slider-dots]');
    options['prevArrow'] = $controls.find('[data-hor-slider-prev]');
    options['nextArrow'] = $controls.find('[data-hor-slider-next]');
  }

  if ($slider.data('custom-dots') == "1") {
    options['appendDots'] = $controls.find('[data-hor-slider-dots]');
  }

  if ($slider.data('dots-titles') == "1") {
    options['customPaging'] = function (slider, i) {
      var title = $(slider.$slides[i]).find('[data-title]').data('title');
      return '<hr><button><span>' + title + '</span></button>';
    }
  }

  if ($slider.data('disable-swipe') == "1") {
    options['swipe'] = false;
    options['swipeToSlide'] = false;
    options['touchMove'] = false;
    options['accessibility'] = false;
  }

  if ($controls.length) {
    $slider.on('init', () => $controls.addClass('m-mounted'));
  }
  if (typeof responsive == 'object') {
    options['responsive'] = responsive;
  }

  if ($slider.data('slides-to-show-ipad')) {
    const ipadBreakpoint = $slider.data('breakpoint-ipad') || 989;
    const mobBreakpoint = $slider.data('breakpoint-mob') || 767;

    options['responsive'] = [{
        breakpoint: ipadBreakpoint,
        settings: {
          slidesToShow: $slider.data('slides-to-show-ipad'),
        }
      },
      {
        breakpoint: mobBreakpoint,
        settings: optionsMobile
      }
    ]
  } else {
    const mobBreakpoint = $slider.data('breakpoint-mob') || 989;

    if ($slider.data('slides-to-show-mob')) {
      options['responsive'] = [{
        breakpoint: mobBreakpoint,
        settings: optionsMobile
      }]
    }
  }

  if ($slider.data('as-nav-for')) {
    const id = $slider.data('as-nav-for');
    options['asNavFor'] = `[data-slider=${id}]`;
    options['focusOnSelect'] = true;
  }

  $slider.not('.slick-initialized').slick(options);

  $slider.on('afterChange', function(event, slick, currentSlide) {
    toggleSlideTabIndex(slick);
  });

  toggleSlideTabIndex($slider);
}

function toggleSlideTabIndex(slider) {
  if (!slider) return;

  let slick;
  if (typeof slider.slick === 'function') {
    slick = slider.slick('getSlick');
  } else {
    slick = slider;
  }

  if (!slick || !slick.$slides || typeof slick.$slides.length === 'undefined') return;

  if(slick.$slides.length > 1) {
    $(slick.$slides).each((index, item) => {
      const selectors = 'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, *[tabindex], *[contenteditable]';

      if ($(item).attr('aria-hidden') === 'true') {
        $(item).find(selectors).attr('tabindex', '-1');
        $(item).attr('tabindex', '-1');
      } else {
        $(item).find(selectors).attr('tabindex', '0');
        $(item).attr('tabindex', '0');
      }
    } )
  }
}

const initializeTestimonialSlider = function () {
  $("#section-review .section-review_slider").slick({
    arrows: false,
    slidesToShow: 4,
    infinite: true,
    slidesToScroll: 1,
    dots: false,
    responsive: [
      {
        breakpoint: 1280,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 820,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 668,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
}


const initializeWhatsNewSlider = function () {
  $("#section-whats-new .section-whatsnew_slider").slick({
    arrows: false,
    dots: false,
    slidesToShow: 3,
    infinite: true,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1280,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 820,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 668,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
}

const initializeFaqSlider = function () {
  if ($(window).width() <= 1200) {
    $("[data-faq-slider]").not('.slick-initialized').slick({
      arrows: false,
      dots: true,
      slidesToShow: 2,
      responsive: [{
        breakpoint: 767,
        settings: {
          slidesToShow: 1
        }
      }]
    })
  }
}

export default function () {
  const $sliders = $('[data-hor-slider]');
  $sliders.each(function (index, slider) {
    const $slider = $(slider);
    mountSlider($slider);
  });

  initializeTestimonialSlider();
  initializeWhatsNewSlider();
  initializeFaqSlider();
};